import React, { useEffect } from "react";
import "./CategoryLayout.scss"
import { useHistory } from "react-router";
const CategoryLayout = ({ data }) => {
    const history = useHistory()

    return (
        <div className="CategoryLayout">
            <div className="title-menu-cat">
                Menu Categories
            </div>
            <div className="data-list-cat">
                {data.map((category, key) => {
                    return (
                        <div className="cat-layout" key={key}
                            onClick={() => {
                                if (category.MetaData?.ShowAsOffer) {
                                    history.push(`/page/offers/${category.MenuCategoryID}`)

                                } else {
                                    history.push(`/page/category/${category.MenuCategoryID}`)
                                }
                            }}>
                            <div className="cat-layout-top">
                                <img alt="" src={category.Image} className="cat-icon" />
                            </div>
                            <div className="cat-layout-btm">

                                {category?.Title?.en?.toLowerCase()}
                            </div>
                        </div>
                    )

                })}
            </div>
        </div>
    )

}
export default CategoryLayout